package uk.co.nickthecoder.kyd.nodes

import uk.co.nickthecoder.glok.backend.backend
import uk.co.nickthecoder.glok.collections.asMutableObservableList
import uk.co.nickthecoder.glok.property.boilerplate.colorProperty
import uk.co.nickthecoder.glok.property.boilerplate.optionalNodeProperty
import uk.co.nickthecoder.glok.property.property
import uk.co.nickthecoder.glok.scene.Color
import uk.co.nickthecoder.glok.scene.Node
import uk.co.nickthecoder.glok.scene.WithContent
import uk.co.nickthecoder.kyd.util.Vector2

class Letterbox(
    nominalSize: Vector2,
    contents: Node? = null,
) : Node(), WithContent {

    val barsColorProperty by colorProperty(Color["#111"])
    var barsColor by barsColorProperty

    val nominalSizeProperty by property<Vector2>(nominalSize)
    var nominalSize by nominalSizeProperty

    val contentProperty by optionalNodeProperty(null)
    override var content by contentProperty

    val mutableChildren = mutableListOf<Node>().asMutableObservableList()
    override val children = mutableChildren.asReadOnly()

    init {
        contentProperty.addChangeListener { _, _, new ->
            mutableChildren.clear()
            if (new != null) {
                mutableChildren.add(new)
            }
            requestLayout()
        }

        mutableChildren.addChangeListener(childrenListener)
        content = contents

        nominalSizeProperty.addListener(requestLayoutListener)
    }


    override fun nodePrefWidth() = 0f
    override fun nodePrefHeight() = 0f

    override fun layoutChildren() {

        content?.let { content ->
            val requiredRatio = nominalSize.x / nominalSize.y
            val actualRatio = width / height

            if (actualRatio <= requiredRatio) {
                // empty bands at the top/bottom
                val childHeight = width / requiredRatio
                setChildBounds(content, 0f, (height - childHeight) / 2, width, childHeight)
            } else {
                // empty bans at the left/right
                val childWidth = height * requiredRatio
                setChildBounds(content, (width - childWidth) / 2, 0f, childWidth, height)
            }
            //println("Content bounds : ${content.sceneX}, ${content.sceneY} : ${content.width} x ${content.height}")
        }
    }

    override fun draw() {
        val content = content ?: return
        if (content.sceneX == sceneX) {
            backend.fillRect(sceneX, sceneY, sceneX + width, content.sceneY, barsColor)
            backend.fillRect(
                sceneX, content.sceneY + content.height, sceneX + width, sceneY + height,
                barsColor
            )
        } else {
            backend.fillRect(sceneX, sceneY, content.sceneX, sceneY + height, barsColor)
            backend.fillRect(
                content.sceneX + content.width, sceneY, sceneX + width, sceneY + height,
                barsColor
            )
        }
    }

}
